import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { SessionService } from "../core/core/session.service";

@Injectable()
export class LoginGuard implements CanActivate {

    constructor(private sessionService: SessionService, private router: Router) { }

    public canActivate(next, state) {
        return this.sessionService.isSessionActive().map(sessionActive => {
            if (sessionActive) {
                this.router.navigate(['/dashboard']);
                return false;
            }
            return true;
        });
    }
}